<template>
	<div class="app">
		<div class="top-fixed">
			<div class="btn-left"><backIcon></backIcon></div>
			<audioIcon ref="audioIcon"></audioIcon>
		</div>

		<Loading v-show="isLoading" :isLoading="isLoading" ref="loadingRef" @done="onLoaded" />
		<div
			v-show="!isLoading"
			class="wrapper"
			ref="wrapper"
			@touchstart.passive="touchStart"
			@touchmove.passive="touchMove"
			@touchend.passive="touchEnd"
			@wheel.passive="onWheel"
		>
			<div class="pages" :style="pageStyle">
				<collectReport :active="index === 0" :bottomBarHeight="bottomBarHeight" @next="getData" />
				<Page3Order :active="index === 1" :reportData="reportData" @audioFinished="audioFinished"/>
				<Page4Store :active="index === 2" :reportData="reportData" />
				<Page5Brand :active="index === 3" :reportData="reportData" />
				<Page6Cumulative :active="index === 4" :reportData="reportData" />
				<Page7CoBranded :active="index === 5" :reportData="reportData" />
				<page8Choice :active="index === 6" :reportData="reportData" />
				<generateReport
					ref="generateReportRef"
					:active="index === 7"
					:reportData="reportData"
					:configData="configData"
					@claimedCoupon="claimedCoupon"
				/>
			</div>
		</div>

		<!-- <div class="bottom-fixed" v-if="index > 0 && index < total">
			<span>*打开库迪咖啡小程序/<span class="letter-dynamic">APP</span><br />查看你的<span class="num-dynamic">2025</span>库迪主理人报告</span>
		</div> -->
		<div class="bottom-fixed tip-container" v-if="index > 0 && index < total">
         <!-- 左侧符号 -->
         <!-- <span class="symbol">*</span> -->
         <!-- 右侧文字块 -->
         <!-- <div class="text-content">
           打开库迪咖啡小程序/<span class="letter-dynamic">APP</span>-【我的】
           <br />
           查看你的<span class="num-dynamic">2025</span>库迪主理人报告
         </div> -->
		 <img src="@/assets/annualReport/left_bottom_prompt.png" alt="" width="30%" />
        </div>
		<div class="up-arrow" v-if="index > 0 && index < total">
			<img src="@/assets/annualReport/up-arrow.png" alt="" wid/>
		</div>
	</div>
</template>

<script>
	import Loading from "./components/Loading.vue";
	import backIcon from "./components/backIcon.vue";
	import audioIcon from "./components/audioIcon.vue";
	import ruleIcon from "./components/ruleIcon.vue";

	import collectReport from "./pages/collectReport.vue";
	import Page3Order from "./pages/Page3Order.vue";
	import Page4Store from "./pages/Page4Store.vue";
	import Page5Brand from "./pages/Page5Brand.vue";
	import Page6Cumulative from "./pages/Page6Cumulative.vue";
	import Page7CoBranded from "./pages/Page7CoBranded.vue";
	import page8Choice from "./pages/page8Choice.vue";
	import generateReport from "./pages/generateReport.vue";
	import {
		getAnnualReport2025,
		getAnnualReportConfig2025,
	} from "@/api/annualReport/index.js";
	import { marketingGetH5Activity } from "@/api";

	export default {
		components: {
			Loading,
			backIcon,
			audioIcon,
			ruleIcon,
			collectReport,
			Page3Order,
			Page4Store,
			Page5Brand,
			Page6Cumulative,
			Page7CoBranded,
			page8Choice,
			generateReport,
		},
		data() {
			return {
				isLoading: false,
				index: 0,
				total: 7,
				locked: false,
				// touch
				sy: 0,
				my: 0,
				isPlaying: false,
				reportData: {
					memberId: null, // 用户ID
					memberNickName: "", // 用户昵称（为空则走手机号掩码）
					hasReport: false, // 是否存在报告
					activityNo: "", // 加密活动号
					activityPopup: "", // 弹窗配置
					userCreateTime: "", // 注册日期 YYYY年M月D日
					createDay: 0, // 注册天数
					cityMdCode: "", // 城市编号
					cityName: "", // 城市名称
					shopMdCode: "", // 门店编号
					shopName: "", // 门店名称
					totalOrderCount: 0, // 下单总次数
					totalBeveragesPurchased: 0, // 购买饮品总数
					participationRate: 0, // 参与度（前端自己计算百分比）
					temperaturePreference: 0, // 冷热喜好 1.冷 2.热 3.冷热均衡
					mostIPName: "", // 购买最多联名项目名称
					// 是否限流
					isLimited: false,
					// 是否领取过优惠券
					hasClaimedCoupon: false,
					blackBox: "",
				},
				configData: {
					isReportEnd: false,
					activityNo: "",
					qrcode:'',
					activityPopup: [],
				},
				bottomBarHeight: 0,
				trackPageConfig: {
					0: 'annual_report_p2_view',
					1: 'annual_report_p3_view',
					2: 'annual_report_p4_view',
					3: 'annual_report_p5_view',
					4: 'annual_report_p6_view',
					5: 'annual_report_p7_view',
					6: 'annual_report_p8_view',
					7: 'annual_report_p9_view'
				}
			};
		},
		computed: {
			pageStyle() {
				return {
					transform:
						this.index * 100 ? `translateY(-${this.index * 100}vh)` : "",
					transition: "transform .6s cubic-bezier(.22,.9,.3,1)",
				};
			},
		},
		mounted() {
			// 进入页面时，给 body 加上锁,防止IOS橡皮筋回弹
            document.body.classList.add('lock-scroll');
			this.setSDKConfig();
			this.getConfig();
			window.initParams=this.initParams
			try {
				queryInitParams.postMessage("")
			} catch (e) {
				console.warn(e);
			}

			this.$sensors.track('annual_report_view')
		},
		beforeDestroy() {
            // 离开页面时，把锁解开，防止影响其他普通页面的滚动
            document.body.classList.remove('lock-scroll');
        },
		methods: {
			initParams(data) {
				if(data && data.bottomBarHeight){
					this.bottomBarHeight = data.bottomBarHeight;
				}
			},
			setSDKConfig() {
				var kuaishouScript = document.createElement("script");

				kuaishouScript.type = "text/javascript";
				kuaishouScript.text = `(function (root) {    var ksscript = document.createElement('script');    ksscript.setAttribute('charset', 'utf-8');    ksscript.src = '//p1-yx.adkwai.com/udata/pkg/ks-ad-trace-sdk/ks-trace.3.2.0.min.js';    var s = document.getElementsByTagName('script')[0];    s.parentNode.insertBefore(ksscript, s);})(window);`;
				document.head.appendChild(kuaishouScript);
				var tongdunScript = document.createElement("script");
				tongdunScript.type = "text/javascript";
				if (process.env.VUE_APP_ENV === "prod") {
					tongdunScript.text = `(function(){
        window._fmOpt = {
          partner: 'cotticoffee',
          appName: 'cotticoffee_h5',
          success: function(data) {
            window.blackbox = data
          }
        };
        var fm = document.createElement('script'); 
        fm.type = 'text/javascript'; fm.async = true;
        fm.src = 'https://static.trustdecision.com/tdfp/cn/7fa1350e97bf428376d94c6dba4103cc/fm.js' + '?t=' + (new Date().getTime()/3600000).toFixed(0);
        var s = document.getElementsByTagName('script')[0]; 
        s.parentNode.insertBefore(fm, s);
      })();`;
				} else {
					tongdunScript.text = `(function(){
        window._fmOpt = {
          partner: 'cotticoffee',
          appName: 'cotticoffee_test',
          success: function(data) {
            window.blackbox = data
          }
        };
        var fm = document.createElement('script'); 
        fm.type = 'text/javascript'; fm.async = true;
        fm.src = 'https://static.trustdecision.com/tdfp/cn/7fa1350e97bf428376d94c6dba4103cc/fm.js' + '?t=' + (new Date().getTime()/3600000).toFixed(0);
        var s = document.getElementsByTagName('script')[0]; 
        s.parentNode.insertBefore(fm, s);
      })();`;
				}
				document.head.appendChild(tongdunScript);
			},
			onLoaded() {
				this.isLoading = false;
				this.index = 1;
			},
			getConfig() {
				// 获取配置
				getAnnualReportConfig2025().then((res) => {
					console.log("年度报告配置", res);
					if (res.code === 200) {
						// 成功获取数据
						this.configData = res.data || {};
						this.configData.activityPopup = (res.data.activityPopup && JSON.parse(res.data.activityPopup)) || [];
						
						if (res.data.isReportEnd === 'true') {
							try {
								let path = { path: "cottitab://coffee?tabName=home" };
								CottiNavigation.postMessage(JSON.stringify(path));
							} catch (e) {
								console.warn(e);
							}
							return;
						}
					}
				});
			},
			getData() {
				this.isLoading = true;
      			this.$sensors.track(this.trackPageConfig[0])
				getAnnualReport2025()
					.then((res) => {
						console.log("年度报告数据", res);
						if (res.code === 200) {
							// 成功获取数据
							this.reportData = res.data || {};

							if(this.configData.activityNo){
								this.checkClaimStatus();
							}
							setTimeout(() => {
								this.$refs.generateReportRef.init();
							}, 2000);
						} else {
							// 返回上一页面
							this.isLoading = false;
							this.index = 0;
						}
						// 处理数据
						// 通知 Loading 组件接口已完成
						if (this.$refs.loadingRef && this.$refs.loadingRef.onApiFinished) {
							this.$refs.loadingRef.onApiFinished();
						}
					})
					.catch((error) => {
						console.error("获取年度报告失败", error);
						// 即使失败也要通知 Loading 组件
						if (this.$refs.loadingRef && this.$refs.loadingRef.onApiFinished) {
							this.$refs.loadingRef.onApiFinished();
						}
					});
			},
			go(i) {
				if (this.locked || i === this.index) return;
				this.curIndex(i);
			},
			curIndex(i) {
				this.locked = true;
				this.index = i;
				setTimeout(() => (this.locked = false), 650);
			},
			next() {
				if (this.index === 0) return;
				this.$sensors.track(this.trackPageConfig[this.index], { action: 'swipe_down' })
				if (this.index < this.total) this.curIndex(this.index + 1);
			},
			prev() {
				if (this.index === 1) return;
				this.$sensors.track(this.trackPageConfig[this.index], { action: 'swipe_up' })
				if (this.index > 0) this.curIndex(this.index - 1);
			},

			// wheel / touch
			onWheel(e) {
				if (this.locked) return;
				if (e.deltaY > 30) this.next();
				if (e.deltaY < -30) this.prev();
			},
			touchStart(e) {
				this.sy = e.touches[0].clientY;
				this.my = e.touches[0].clientY; // 初始化 my
			},
			touchMove(e) {
				this.my = e.touches[0].clientY;
			},
			touchEnd() {
				const d = this.sy - this.my;
				// 判断是否为滑动操作：滑动距离大于 50px
				if (Math.abs(d) < 50) return;
				d > 0 ? this.next() : this.prev();
			},
			onKey(e) {
				if (this.locked) return;
				if (e.key === "ArrowDown") this.next();
				if (e.key === "ArrowUp") this.prev();
			},
			claimedCoupon() {
				this.checkClaimStatus();
			},
			// 查询领取活动
		   async checkClaimStatus() {
              let data = {
                activityNo: this.configData.activityNo,
              };
              let res = await marketingGetH5Activity(data);
              console.log(res);
              if (res.busCode === "1") {
                // 未限流
                // this.reportData.isLimited = false;
                this.$set(this.reportData, "isLimited", false);
                // 是否领取过优惠券
                // this.reportData.hasClaimedCoupon = res.data.status === 1 ? res.data.unReceiveCoupon : true;
                const status = res.data.status === 1 ? res.data.unReceiveCoupon : true;
                this.$set(this.reportData, "hasClaimedCoupon", status);
              } else {
                // 限流
                // this.reportData.isLimited = true;
                // this.reportData.hasClaimedCoupon = true;
                this.$set(this.reportData, "isLimited", true);
                this.$set(this.reportData, "hasClaimedCoupon", true);
              }
            },
      audioFinished() {
      if(!this.$refs.audioIcon.isPlaying) {
        this.$refs.audioIcon.togglePlay();
      }
     },
		},
	};
</script>
<style lang="scss" scoped>
	.app {
		height: 100vh;
		width: 100%;
		overflow: hidden;
		position: relative;
	}
	.wrapper {
		height: 100vh;
		width: 100%;
		overflow: hidden;
		position: relative;
	}
	.top-fixed {
		position: absolute;
		width: 100%;
		top: 115px;
		left: 0;
		z-index: 2;
		display: flex;
		justify-content: space-between;
		padding: 0 32px;
		box-sizing: border-box;
		.btn-left {
			display: flex;
			gap: 18px;
		}
	}
	.bottom-fixed {
		position: absolute;
		width: 100%;
		bottom: 57px;
		left: 41px;
		z-index: 2;
		text-align: left;
		opacity: 0.6;

		font-family: SourceHanSansSC, SourceHanSansSC;
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		line-height: 24px;
		visibility: hidden;
        animation: showInstantly 0s 1.4s forwards;
	}
	@keyframes showInstantly {
    to {
      visibility: visible;
    }
    }
	.up-arrow {
		position: absolute;
		bottom: 50px;
		left: 50%;
		transform: translateX(-50%);
		img {
			width: 53px;
			height: 36px;
		}
	}
	/* 图片应用动画 */
    .up-arrow img {
	    width: 53px;
		height: 36px;
        display: block;
      
      /* 核心动画配置 */
      /* 动画名称 | 时长 | 速度曲线 | 延迟 | 次数 */
      animation: moveUpFade 1.5s ease-in-out infinite;
      
      /* 性能优化：告诉浏览器这个元素会变动，开启硬件加速 */
      will-change: transform, opacity;
    }
    
    /* 定义动画关键帧 */
    @keyframes moveUpFade {
      0% {
        /* 初始状态：位置稍低，透明 */
        opacity: 0;
        transform: translate3d(0, 10px, 0); 
      }
      30% {
        /* 中间状态：完全显示，回到原点 */
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
      100% {
        /* 结束状态：向上移动一段距离，再次变透明 */
        opacity: 0;
        transform: translate3d(0, -15px, 0);
      }
    }
	.tip-container {
      display: flex;
      align-items: flex-start; /* 顶部对齐 */
      gap: 4px; /* 符号和文字之间的间距 */
      /* 以下是为了美观的额外设置，可根据需要调整 */
      font-size: 12px; 
      line-height: 1.5;
    }
	.letter-dynamic {
		font-family: "MontserratRoman-Medium";
	}
	.num-dynamic {
		font-size: 13px;
		font-family: "MontserratRoman-SemiBold";
	}
</style>
